import Vue from "vue";
import Vuex from "vuex";
import service from "../../services/gruposDeFeriados/holidays";
import holidays from "../../models/gruposDeFeriado/holidays";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    service: new service(),
    paddingNav: '10px',
    holidays: [],
    holidaysNager: [],
    openHolidays: false,
    mode: 'Agregar feriado',
    new: {},
    edit: {},
    itemDelete: null,
    openDelete: false,
    newHolidays: []
  },

  mutations: {
    setPaddingNav(state, data) {
      state.paddingNav = data;
    },
    setHolidaysGroups(state, data) {
      state.holidaysGroups = data;
    },
    setHolidays(state, data) {
      state.holidays = data;
    },
    setHolidaysNager(state, data) {
      state.holidaysNager = data;
    },
    setOpenHoliday(state, data) {
      state.openHolidays = data;
    },
    setOpenDelete(state, data) {
      state.openDelete = data;
    },
    setItemDelete(state, data) {
      state.itemDelete = data;
    },
    setMode(state, data) {
      state.mode = data;
    },
    setNewHoliday(state, data) {
      state.new = data;
    },
    setEditHoliday(state, data) {
      state.edit = data;
    },
    setNewHolidays(state, data) {
      state.newHolidays = data;
    }

  },
  actions: {

    async getHolidays(state) {
      return new Promise(async (resolve, reject) => {
        try {
          let item = await state.state.service.getHolidays();
          state.commit("setHolidays", item);
          resolve(true);
        } catch (error) {
          reject(error);
        }
      });

    },

    async getHolidayId({ state, commit }, id) {
      try {
        const data = await state.service.getHolidayId(id);
        commit("setEditHoliday", data);
        return true;
      } catch (error) {
        throw error;
      }
    },

    async getHolidaysNager({ state, commit }, year){
      return new Promise(async (resolve, reject) => {
        try {
          let item = await state.service.getHolidaysCurrentYearNager(year);
          commit("setHolidaysNager", item);
          resolve(true);
        } catch (error) {
          reject(error);
        }
      });
    },

    async addHolidays(state) {
      try {
        await state.state.service.addHolidays(state.state.newHolidays)
          .then(() => {
            resolve(true);
          });
      } catch (error) {
        return false;
      }
    },

    async addHoliday(state) {
      try {
        await state.state.service.addHoliday(state.state.new)
          .then(({ data }) => {
            let item = state.state.new;
            let options = state.state.holidays;
            let newItem = holidays.fromJson({
              feriadoId: data.feriadoId,
              nombre: item.nombre,
              fecha: item.fecha,
              fijo: item.fijo
            });
            options.unshift(newItem);
            state.commit("setEditHoliday", options);
            resolve(true);
          });
      } catch (error) {
        return false;
      }
    },

    async deleteHoliday(state) {
      return new Promise(async (resolve, reject) => {
        try {
          await state.state.service.deleteHoliday(state.state.itemDelete).then(() => {
            let options = state.state.holidays
            options = options.filter(option => {
              return option.id != state.state.itemDelete
            })
            state.commit('setHolidays', options)
            resolve(true)
          });
        } catch (error) {
          reject(error)

        }
      })
    },

    async editHoliday(state) {
      return new Promise(async (resolve, reject) => {
        try {
          await state.state.service.editHoliday(state.state.edit).then(() => {
            let item = state.state.edit;
            let options = state.state.holidays
            options = options.map((option) => {
              if (option.id !== item.id) {
                return option
              }
              item = holidays.fromJson({
                feriadoId: item.id,
                nombre: item.nombre,
                fecha: item.fecha,
                fijo: item.fijo
              });
              return item
            });

            state.commit('setHolidays', options)
            resolve(true);
          });
        } catch (error) {
          reject(error);
        }
      });
    },


  },
});
